import * as IsActive from '../../components/is_active'
import * as Request from '../../request'
import * as Constants from './constants'

export type UpdateLeadTextStatus = Request.Request

export const updateLeadTextStatus: UpdateLeadTextStatus = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.LEAD_TEXT_STATUS_UPDATE)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `/lead-text/${community}/${stateChange.id}`,
  })

export const fetchLeadTexts: IsActive.FilteredFetcher = IsActive.filteredFetchAction(
  Constants.FETCH_LEAD_TEXT,
  Constants.SERVER_RESOURCE,
)

export const fetchLeadTextByDate: any = IsActive.filteredDateFetchAction(
  Constants.FETCH_LEAD_TEXT,
  Constants.SERVER_RESOURCE,
)



// WEBPACK FOOTER //
// ./src/pages/lead-text/actions.ts